var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"center"},[_c('router-link',{attrs:{"to":{ name: 'userhome' }}},[_vm._v(" Back home ")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('h1',[_vm._v("Purchase Complete!")])])
}]

export { render, staticRenderFns }